import React from 'react';
import { Construct } from '@carbon/pictograms-react';
import { EmptyState } from 'components/EmptyState';

const EmptyStatePage = () => {
  return (
    <EmptyState>
      <div className="undelivered-emails-no-data--wrapper">
        <Construct />
        <div className="undelivered-emails-empty-state-heading">
          There is no data to display
        </div>
      </div>
    </EmptyState>
  );
};

EmptyStatePage.displayName = 'EmptyStatePage';
export default EmptyStatePage;
